import { Box, FormControl, FormControlLabel, FormHelperText, IconButton, Radio, RadioGroup, Typography } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { useState, useEffect } from "react";
import { MobileButton, RepLIProviderTextField } from "../../../components";
import { geneticCancerGene, geneticTestingTypes } from "../../../data/db";
import { arrayOfNumbers } from "../../../services/util.service";
import useStyles from "./GeneticTesting.style";
import { AppSelect } from "./InputComponents";
import multiItemQuestion from './MultiItemQuestion.component';
import geneticIcon from '../../../images/icon_genetic.png';
import { useTranslation } from "react-i18next";

const GeneticTesting = props => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [autoUpdate, setAutoUpdate] = useState(false);

    let birthYear = new Date(props.dateOfBirth).getFullYear();
    let firstYear = birthYear + 10;
    let currentYear = new Date(Date.now()).getFullYear();
    
    let geneticTestingYears = arrayOfNumbers(firstYear, currentYear - firstYear + 1);

    
   




    useEffect(() => {
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.items]);

    return (
        <Box className={classes.root}>
            {/* Header */}
            <Box><img src={geneticIcon} alt="logo" /></Box>
            <Typography variant="h4" className={classes.title}>Genetic Testing</Typography>

            {/* Validation Errors */}
            {props.error && !props.validator.allValid() &&
                <Typography color="error">
                    Please review your answers
                </Typography>
            }

            {/* Genetic Testing */}
            <Box className={classes.inputSection}>
                <Typography variant="h5">Have you had any genetic testing before?
                {
                <span className={props.error && !props.validator.fieldValid('anyGeneticTesting') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                }
                </Typography>
                <FormControl component="fieldset"
                    error={props.error && !props.validator.fieldValid('anyGeneticTesting')}>
                    <RadioGroup row
                        aria-label="Genetic Testing"
                        value={props.anyGeneticTesting}
                        onChange={props.onGenticTestingChange}
                    >
                        {["Yes", "No", "Unsure"].map((answer, i) =>
                            <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                        )}
                    </RadioGroup>
                    <FormHelperText>
                        {props.validator.message('anyGeneticTesting', props.anyGeneticTesting, 'required')}
                    </FormHelperText>
                </FormControl>
            </Box>

            {/* Genetic Testings */}
            <Box display={props.anyGeneticTesting === 'Yes' ? 'block' : 'none'}>
                {
                    props.items.map((testing, i) =>
                        <Box className={classes.item} key={i}>
                            {/* Testing Header */}
                            <Box className={classes.itemHeader}>
                                <span>{t('common.substantive.geneticTest')} #{i + 1}</span>
                                {i !== 0 &&
                                    <IconButton aria-label="delete" color="inherit" onClick={props.onRemove(i)}>
                                        <DeleteIcon />
                                    </IconButton>
                                }
                            </Box>
                            {/* Testing Body */}
                            <Box className={classes.itemBody}>
                                <Box className={classes.inputSection}>
                                    {/* Genetic Testing Types */}
                                    <Typography className={classes.marginStyle} variant="h5">what type of genetic testing did you have?

                                    {
                                    <span className={props.error && !props.validator.fieldValid(`test_#${i + 1}_type`)? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                    }
                                    </Typography>
                                    <AppSelect
                                        id={`geneticTestingType${i + 1}`}
                                        label="type"
                                        value={testing.testType}
                                        items={[...geneticTestingTypes]}
                                        onChange={props.onChange(i, 'testType')}
                                        fullWidth
                                        error={props.error && !props.validator.fieldValid(`test_#${i + 1}_type`)}
                                        helperText={props.validator.message(`test_#${i + 1}_type`, testing.testType, 'required')}
                                    />
                                </Box>

                                <Box className={classes.inputSection}>
                                    <Typography className={classes.marginStyle} variant="h5">Did your genetic testing find a positive result (genetic abnormality)?
                                    {
                                    <span className={props.error && !props.validator.fieldValid(`test_#${i + 1}_anyPositiveGeneticTesting`)? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                    }
                                    </Typography>
                                    <FormControl component="fieldset"
                                        error={props.error && !props.validator.fieldValid(`test_#${i + 1}_anyPositiveGeneticTesting`)}>
                                        <RadioGroup row
                                            aria-label="Genetic Testing"
                                            value={testing.anyPositiveGeneticTesting}
                                            onChange={e => props.onPositiveGeneticTestingChange(i, e.target.value)}
                                        >
                                            {["Yes", "No", "Unsure"].map((answer, i) =>
                                                <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                            )}
                                        </RadioGroup>
                                        <FormHelperText>
                                            {props.validator.message(`test_#${i + 1}_anyPositiveGeneticTesting`, testing.anyPositiveGeneticTesting, 'required')}
                                        </FormHelperText>
                                    </FormControl>
                                </Box>

                                <Box display={testing.anyPositiveGeneticTesting === 'Yes' ? 'block' : 'none'}>

                                    {/* Genetic Testing Screnning */}
                                    <Box className={classes.inputSection}
                                        display={(testing.testType === 'Other' || testing.testType === 'Carrier screening') ? 'block' : 'none'}>
                                        <Typography className={classes.marginStyle} variant="h5">what did your positive carrier screening test show?
                                        {
                                    <span className={props.error && !props.validator.fieldValid(`test_#${i + 1}_otherTestType`)? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                    }
                                        </Typography>
                                        <RepLIProviderTextField
                                            label="Please fill the response*"
                                            value={testing.otherTestType}
                                            inputProps={{ maxLength: 2500 }}
                                            //onChange={props.onChange(i, 'otherTestType')}
                                            onChange={e => props.positiveCarrierGTChanges(e, 'otherTestType', i)}
                                            autoFocus
                                            error={props.error && !props.validator.fieldValid(`test_#${i + 1}_otherTestType`)}
                                            helperText={props.validator.message(`test_#${i + 1}_otherTestType`, testing.otherTestType, `other_testType:${testing.testType + ',' + testing.anyPositiveGeneticTesting}`)}
                                        />
                                    </Box>

                                    <Box className={classes.inputSection} display={testing.testType === 'Cancer genetic testing' ? 'block' : 'none'}>
                                        {/* Genetic Cancer Testing Gene Types */}
                                        <Typography className={classes.marginStyle} variant="h5">what gene had a positive result in it?
                                        </Typography>
                                        <AppSelect
                                            id={`cancerGeneType${i + 1}`}
                                            label="type"
                                            value={testing.cancerGeneType}
                                            items={[...geneticCancerGene]}
                                            onChange={props.onChange(i, 'cancerGeneType')}
                                            fullWidth
                                            error={props.error && !props.validator.fieldValid(`test_#${i + 1}_cancerGeneType`)}
                                            helperText={props.validator.message(`test_#${i + 1}_cancerGeneType`, testing.cancerGeneType, `cancer_geneType:${testing.testType + ',' + testing.anyPositiveGeneticTesting}`)}
                                        />

                                    </Box>

                                    {/* Genetic Testing Year */}
                                    <Box className={classes.inputSection}>
                                        <Typography className={classes.marginStyle} variant="h5">Year of Genetic Testing
                                        {
                                    <span className={props.error && !props.validator.fieldValid(`test_#${i + 1}_year`)? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                    }
                                        </Typography>
                                        <AppSelect
                                            id={`testingYear${i + 1}`}
                                            label="Year"
                                            value={testing.year}
                                            items={['Unknown',...geneticTestingYears]}
                                            onChange={props.onChange(i, 'year')}
                                            fullWidth
                                            error={props.error && !props.validator.fieldValid(`test_#${i + 1}_year`)}
                                            helperText={props.validator.message(`test_#${i + 1}_year`, testing.year, `test_field_req:${testing.anyPositiveGeneticTesting}`)}
                                        />
                                    </Box>

                                    {/* copy of the testing */}
                                    <Box className={classes.inputSection}>
                                        <Typography className={classes.marginStyle} variant="h5">Do you have a copy of the result to bring to your doctor?
                                        {
                                        <span className={props.error && !props.validator.fieldValid(`test_#${i + 1}_copyOfGeneticTesting`)? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                        }
                                        </Typography>
                                        <FormControl component="fieldset"
                                            error={props.error && !props.validator.fieldValid(`test_#${i + 1}_copyOfGeneticTesting`)}>
                                            <RadioGroup row
                                                aria-label="Genetic Testing"
                                                value={testing.copyOfGeneticTesting}
                                                onChange={props.onChange(i, 'copyOfGeneticTesting')}
                                            >
                                                {["Yes", "No", "Unsure"].map((answer, i) =>
                                                    <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                )}
                                            </RadioGroup>
                                            <FormHelperText style={{ textAlign: 'center' }}>
                                                {props.validator.message(`test_#${i + 1}_copyOfGeneticTesting`, testing.copyOfGeneticTesting, `test_field_req:${testing.anyPositiveGeneticTesting}`)}
                                            </FormHelperText>
                                        </FormControl>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )
                }
                <MobileButton
                    onClick={props.onAdd}
                    color="primary"
                    label="Add Testing"
                    endIcon={<AddIcon />}
                />
            </Box>
        </Box >
    );
};

export default multiItemQuestion(GeneticTesting, {
    testType: '',
    otherTestType: '',
    cancerGeneType: '',
    year: '',
    copyOfGeneticTesting: '',
});
